import {on} from '@ngrx/store';
import * as CharacterActions from './character.actions';
import {Character, Roll} from 'gamesis-story-client';
import {createRehydrateReducer} from '../rehydrate.reducer';
import {exitCampaign} from '../campaigns/campaign.actions';
import {unauthenticated} from '../app/app.actions';

export interface RollState {
    [character: string]: Roll[];
}

export interface CharacterState {
    characters: Character[];
    myCharacters: string [];
    rolls: RollState;
    loading: boolean;
    error: any;
}

const initialState: CharacterState = {
    characters: [],
    myCharacters: [],
    rolls: {},
    loading: false,
    error: null
};

const _characterReducer = createRehydrateReducer(
    'characters',
    initialState,
    on(CharacterActions.loadCharacters, state => ({...state, loading: true})),
    on(CharacterActions.loadCharactersSuccess,
        CharacterActions.addCharacterSuccess,
        CharacterActions.loadCharacterSuccess,
        CharacterActions.activateCharacterSuccess,
        CharacterActions.deactivateCharacterSuccess,
        CharacterActions.deleteCharacterSuccess,
        CharacterActions.deleteRollSuccess,
        CharacterActions.loadCharacterRollsSuccess,
        (state) => ({
            ...state,
            loading: false
        })),
    on(CharacterActions.loadCharactersSuccess, (state, {characters, myCharacters}) => ({
        ...state,
        characters,
        myCharacters
    })),
    on(CharacterActions.charactersFailure, (state, {error}) => ({...state, loading: false, error})),
    on(CharacterActions.addCharacterSuccess, (state, {character}) => ({
        ...state,
        characters: [...state.characters, character],
    })),
    on(CharacterActions.loadCharacterSuccess, (state, {character}) => ({
        ...state,
        characters: state.characters.map(c => c.id === character.id ? character : c),
    })),
    on(CharacterActions.deleteCharacterSuccess, (state, {id}) => ({
        ...state,
        characters: state.characters.filter(c => c.id !== id),
    })),
    on(CharacterActions.activateCharacterSuccess, (state, {id}) => ({
        ...state,
        characters: state.characters.map(character => character.id === id ? {
            ...character,
            active: true
        } : character),
    })),
    on(CharacterActions.deactivateCharacterSuccess, (state, {id}) => ({
        ...state,
        characters: state.characters.map(character => character.id === id ? {
            ...character,
            active: false
        } : character),
    })),
    on(CharacterActions.loadCharacterRollsSuccess, (state, {id, rolls}) => {
        const rollState = {...state.rolls};
        rollState[id] = rolls;
        return ({...state, rolls: rollState});
    }),
    on(CharacterActions.deleteRollSuccess, (state, {id}) => {
        const rollState = {...state.rolls};
        delete rollState[id];
        return ({...state, rolls: rollState});
    }),
    on(exitCampaign, unauthenticated, (state) => initialState),
);

export function characterReducer(state, action) {
    return _characterReducer(state, action);
}
